import useFetch from "../../../hooks/useFetch";

const useMiniERPExportAPI = () => {
  const [fetchData] = useFetch();

  const exportJSON = async (payload, token) => {
    return fetchData(
      {
        url: "/minierp/export/json",
        method: "post",
        data: payload,
        headers: {
          Authorization: token,
        },
        responseType: "blob",
      },
      { silent: false }
    );
  };

  const exportTally = async (payload, token) => {
    return fetchData(
      {
        url: "/minierp/export/tally",
        method: "post",
        data: payload,
        headers: {
          Authorization: token,
        },
        responseType: "blob",
      },
      { silent: false }
    );
  };

  const previewExport = async (payload, token) => {
    return fetchData(
      {
        url: "/minierp/export/preview",
        method: "post",
        data: payload,
        headers: {
          Authorization: token,
        },
      },
      { silent: false }
    );
  };

  return {
    exportJSON,
    exportTally,
    previewExport,
  };
};

export default useMiniERPExportAPI;